import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import helpers from 'src/styles/helpers';
import sections from 'src/styles/sections';
// import breakpointsFunc from 'src/styles/breakpointsFunc';

const useBillingDetailsStyles = makeStyles(_objectSpread(_objectSpread(_objectSpread({}, helpers), sections), {}, {
  blocksList: {
    border: "1px solid ".concat(palette.shades[300]),
    borderRadius: '2px',
    marginTop: '24px'
  },
  blockListItem: {
    padding: '24px 32px',
    '& + &': {
      borderTop: "1px solid ".concat(palette.shades[300])
    }
  },
  billItem: {
    padding: '12px 32px',
    '& + &': {
      borderTop: "1px solid ".concat(palette.shades[300])
    }
  },
  datePicker: {
    flexShrink: '0',
    marginTop: '18px',
    width: '180px'
  },
  flex: {
    alignItems: 'center',
    display: 'flex'
  },
  whiteBlock: {
    padding: '18px 24px',
    backgroundColor: palette.shades[100]
  },
  inlineTooltip: {
    marginLeft: '4px',
    padding: '0'
  }
}));
export default useBillingDetailsStyles;